module.exports = "https://cdn.hellotech.com/client-assets/mount_ready_3cac167d5e3236deef5d0401d5a4d782.png";